import { Component, Input } from '@angular/core';

/**
 * Standard expandable section used by the event details dialog.
 * The content is projected so each section can be implemented independently.
 */
@Component({
    selector: 'event-details-section',
    template: require('./event-details-section.component.html'),
    styles: [require('./event-details-section.component.css')]
})
export class EventDetailsSectionComponent {

    @Input() label: string;

    @Input() secondaryLabel: string;

    @Input() expanded = false;

}
